<template>
    <div>
        <card-header title="Users" icon="fa-users"/>

        <card-body>
            <card-list>
                <search-list-item @action="searchUser"/>
<!--                <subheader-list-item title="Recently Accessed" icon="fa-history"/>-->
<!--                <user-tile v-for="user in recentUsers" :card="card" :user="user" :active="user.active" @click="$openCard('user', {userId: user.id}, card)"/>-->
<!--                <container-list-item padded v-if="recentUsers.length === 0" class="has-text-grey is-size-7">Loading...</container-list-item>-->
                <subheader-list-item title="Active Users" :badge="activeUsers.length" icon="fa-user-circle"/>
                <container-list-item padded v-if="activeUsers.length === 0" class="has-text-grey is-size-7"><i class="fas fa-spinner fa-spin fa-fw mr-2 ml-2"></i>Loading...</container-list-item>
                <user-tile v-for="user in activeUsers" :card="card" :user="user" :active="user.active" @click="$openCard('user', {userId: user.id}, card)"/>
                <subheader-list-item title="New Users" icon="fa-user-plus" :badge="newUsers.length"/>
                <container-list-item padded v-if="newUsers.length === 0" class="has-text-grey is-size-7"><i class="fas fa-spinner fa-spin fa-fw mr-2 ml-2"></i>Loading...</container-list-item>

                <user-tile v-for="user in newUsers" :card="card" :user="user" :active="user.active" @click="$openCard('user', {userId: user.id}, card)"/>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SearchListItem from "@/TIER/components/SearchListItem";

    import UserTile from "../../components/tiles/UserTile";
    import {client as http} from '@/http_client';

    import async from 'async';
    import ContainerListItem from "../../TIER/components/ContainerListItem";

    export default {
        components: {ContainerListItem, CardHeader, CardBody, CardList, UserTile, SubheaderListItem, SearchListItem},
        props: ['card', 'child'],
        methods: {

            searchUser: function (q) {
                this.$openCard('user-search', {query: q}, this.card);
            },
            loadUsers: function (forced) {
                // this.$emit('loading', true);
                let that = this;
                async.parallel([
                    function (cb) {
                        http.get('users/active/0/30', {force: forced}).then(response => {
                            async.eachSeries(response.data, (u, eCB) => {
                                u.active = false;
                                eCB();
                            }, () => {
                                that.activeUsers = response.data;
                                cb();
                            });
                        });
                    },
                    function (cb) {
                        http.get('users/recent/0/30', {force: forced}).then(response => {
                            async.eachSeries(response.data, (u, eCB) => {
                                u.active = false;
                                eCB();
                            }, () => {
                                that.recentUsers = response.data;
                                cb();
                            });
                        });
                    },
                    function (cb) {
                        http.get('users/new/0/30', {force: forced}).then(response => {
                            async.eachSeries(response.data, (u, eCB) => {
                                u.active = false;
                                eCB();
                            }, () => {
                                that.newUsers = response.data;
                                cb();
                            });
                        });
                    }
                ], err => {
                    this.$emit('loading', false);
                    this.setActive();
                });
            },
            reload: function () {
                this.loadUsers(true);
            },
            setActive: function () {
                let check = (this.child && this.child.definition.component === 'user') ? parseInt(this.child.props.userId) : null;
                this.recentUsers.map(u => u.active = (u.id === check));
                this.activeUsers.map(u => u.active = (u.id === check));
                this.newUsers.map(u => u.active = (u.id === check));
            }
        },
        data() {
            return {
                recentUsers: [],
                activeUsers: [],
                newUsers: []
            };
        },
        watch: {
            'child': function () {
                this.setActive();
            }
        },
        mounted: function () {
            this.loadUsers();
        }
    };
</script>

<style lang="scss" scoped>

</style>
